import { SECTORS_MAX, SECTORS_MIN } from "@/lib/location-scene-3d/platform"

/** Digits only, no longer than SECTORS_MAX. Empty stays empty while typing. */
export function sectorsDraftFromRaw(raw: string): string {
  return raw.replace(/\D/g, "").slice(0, String(SECTORS_MAX).length)
}

/** Empty draft is the minimum. Any other draft is clamped to SECTORS_MIN…SECTORS_MAX. */
export function sectorsFromDraft(draft: string): number {
  if (draft === "") return SECTORS_MIN
  const value = Number(draft)
  if (!Number.isFinite(value)) return SECTORS_MIN
  return Math.min(SECTORS_MAX, Math.max(SECTORS_MIN, Math.round(value)))
}
